module.exports = __webpack_public_path__ + "img/icon-3.a8f7a810.png";